export default __webpack_public_path__ + "static/media/four.8814fef7.jpg";